module.exports = __webpack_public_path__ + "static/media/choose.60199c5e.mp4";